export const purple = '#885ADD';
export const lavender = '#BC89FF';

export const primary = purple;
export const onDarkSurfacePrimary = lavender;
